module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.answer.atxt)
    },
    on: {
      "blur": _vm.save,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.answer, "atxt", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ddac99a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/questions/textarea.vue
// module id = 498
// module chunks = 1